"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterBase = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var AttributeFilterRenderer_1 = require("./Components/AttributeFilterRenderer");
var utils_1 = require("./utils");
var AttributeFilterProviders_1 = require("./AttributeFilterProviders");
/**
 * @internal
 */
exports.AttributeFilterBase = function (props) {
    var backend = sdk_ui_1.useBackendStrict(props.backend, "AttributeFilter");
    utils_1.validateAttributeFilterProps(tslib_1.__assign({ backend: backend }, props));
    return (react_1.default.createElement(AttributeFilterProviders_1.AttributeFilterProviders, tslib_1.__assign({}, props),
        react_1.default.createElement(AttributeFilterRenderer_1.AttributeFilterRenderer, null)));
};
//# sourceMappingURL=AttributeFilterBase.js.map